import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/shared/api/client';

export interface Features {
  experimental: boolean;
}

export const featuresKey = ['features'] as const;

/**
 * GET /features: which switches the API runs with. `experimental` is the API's
 * EXPERIMENTAL_FEATURES_ENABLED, the one switch for Stories, Ads and Slideshows. Read at runtime (the
 * bundle is built once in CI), so setting it on the api service is enough. The API's guards enforce
 * it; the dashboard only hides the surfaces.
 */
export function useFeatures() {
  return useQuery({
    queryKey: featuresKey,
    queryFn: async () => (await apiClient.get<Features>('/features', { _silent: true } as Parameters<typeof apiClient.get>[1])).data,
    staleTime: Infinity,
    retry: 1,
  });
}

/** True once the API has said Stories, Ads and Slideshows are on; false while loading or on error. */
export function useExperimentalFeatures(): boolean {
  return useFeatures().data?.experimental === true;
}
